import { Component, inject } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonForm } from '@shared/button-form/button-form';
import { AuthService } from '@core/services/auth/auth-service';
import { LocalStorageService } from '@core/services/localStorage/local-storage.service';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule, ButtonForm],
  templateUrl: './not-found.html',
  styleUrl: './not-found.css',
})
export class NotFoundComponent {
  private router = inject(Router);
  private location = inject(Location);
  private authService = inject(AuthService);
  private localStorageService = inject(LocalStorageService);

  /** Renvoie l'utilisateur vers son tableau de bord (ou la connexion) */
  goHome() {
    this.router.navigate([this.homeRoute()]);
  }

  goBack() {
    this.location.back();
  }

  private homeRoute(): string {
    if (!this.authService.isAuthenticated()) {
      return '/auth';
    }

    switch (this.localStorageService.getRole()) {
      case 'SUPER_ADMIN':
        return '/super-admin/dashboard';
      case 'ADMIN':
        return '/admin/dashboard';
      case 'GERANT':
      case 'AGENT':
      case 'MANAGER':
        return '/manager/dashboard';
      default:
        return '/auth';
    }
  }
}
